'use client';

import { FC } from 'react';

import { Message, MessageContent } from '@/components/common';
import { SuggestionItemGroup } from '@/components/features/Editor';
import { cn } from '@/lib/utils';
import { User } from '@/types/auth';
import { ChatMessage } from '@/types/chat';

interface Props {
  user: User | null;
  message: ChatMessage;
  possibleCommands?: SuggestionItemGroup[];
}

const UserMessage: FC<Props> = ({ user, message, possibleCommands }) => {
  if (!user) {
    return null;
  }

  return (
    <Message key={message.id} className={cn('justify-end')}>
      <div className='relative flex flex-col group/message'>
        <MessageContent
          className={cn(
            'chat-copy rounded-xl p-4 pt-3',
            // The same surface and hairline as the working panel and the
            // citation preview, so every box in the drawer matches.
            'bg-[var(--chakra-colors-cards-bg)] text-fg-default border border-[var(--chakra-colors-border-light)]'
          )}
          possibleCommands={possibleCommands}
        >
          {message.content}
        </MessageContent>

        <span className={cn('text-xs text-fg-muted mt-0.5 px-2 text-right')}>
          {message.timestamp}
        </span>
      </div>

      {/* <MessageAvatar
        src={user.profile_picture?.url || ''}
        alt='User'
        fallback={
          user?.first_name?.[0]?.toUpperCase() ||
          user?.email?.[0]?.toUpperCase() ||
          '?'
        }
      /> */}
    </Message>
  );
};

export { UserMessage };
